<template>
  <div class="ManageExamInfo">
    <b-modal
      v-model="showLoading"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <div class="text-center">
        <div
          class="p-5 rounded d-flex align-items-center justify-content-center"
        >
          <div class="align-items-center">
            <b-spinner
              variant="primary"
              label="Spinning"
              style="width: 3rem; height: 3rem;"
            ></b-spinner>
            <div class="ml-3">
              <h2 class="mt-2">กรุณารอสักครู่</h2>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <draggable
      :list="exam.sections"
      class="list-group"
      disabled="dragging"
    >
      <div
        class="exam-each-section"
        v-for="(section, sectionIndex) in exam.sections"
        :key="sectionIndex"
        style="padding-left: 25px;"
      >
        <ul>
          <li class="background-sections">
            <div class="sections-header">
              <div class="sections-title">
                <div class="exam-sections mr-3">
                  <span> Section </span> {{ sectionIndex + 1 }}
                </div>
                <div class="exam-sections-name">
                  {{ section.title }}
                </div>
              </div>
            </div>
            <div
              :id="section.id"
            >
              <div class="mt-2">
                <div class="sections-info">
                  <b-col class="mt-3 b-col-sectiontitle">
                    <span class="exam-sections-name" for="input-with-list"
                      >ชื่อ Section</span
                    >
                    <div>
                      {{ section.title }}
                    </div>
                  </b-col>
                </div>
                <hr class="mt-4" />
              </div>

              <PreviewQuestionInfo
                :questions="section.questions"
                :section="section"
                :sectionIndex="sectionIndex"
                :key="componentKey"
              />
            </div>
          </li>
        </ul>
      </div>
    </draggable>
  </div>
</template>

<script>
import "@toast-ui/editor/dist/toastui-editor.css";
import { mapActions, mapGetters } from "vuex";
import draggable from "csq-vue-multi-draggable";
import PreviewQuestionInfo from "./PreviewQuestionInfo.vue";

export default {
  components: {
    draggable,
    PreviewQuestionInfo,
  },

  data() {
    return {
      token: localStorage.getItem("token"),
      examId: this.$route.params.quizExamId,
      dragging: false,
      questionType: [
        { text: "คำถามหลายตัวเลือก", value: "MULTIPLE_CHOICE" },
        { text: "คำถามเติมคำ", value: "FILL_BLANK" },
        { text: "คำถามตามบทความ", value: "PASSAGE" },
        { text: "คำถามที่มีคำถามย่อย", value: "BUNDLE" },
        // { text: "คำถามจับคู่", value: "MATCHING" },
      ],
      componentKey: 0,
      showLoading: false,
    };
  },

  created() {
    this.fetchExamsById();
  },

  computed: {
    ...mapGetters("ExamBuilder", [
      "exam",
    ]),

    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },

    dragOptions() {
      return {
        animation: 100,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },

  methods: {
    ...mapActions("ExamBuilder", [
      "findExamsbyId",
      "countSectionAndQuestion",
    ]),

    async fetchExamsById() {
      await this.findExamsbyId(this.examId);

      this.exam.sections.forEach((section) => {
        this.$set(this.collapsedSections, section.id, true);
      });
    },

  },
};
</script>

<style lang="css" scoped>
h4 {
  margin-top: 50px;
}
.handle {
  cursor: move;
}
.exam-each-section {
  display: flex;
  background-color: #f0f0f0;
  list-style-type: none;
  margin-top: 20px;
  padding: 20px 25px 5px 0px;
  border: 1px solid #d3d9de;
  border-radius: 4px;
  opacity: 1;
}

.background-sections {
  width: 100%;
}

.icon-move-sections {
  margin: 7px 2px 0px 2px;
}
.sections-header {
  display: flex;
  justify-content: space-between;
}

.b-col-sectiontitle {
  padding: 0 !important;
}

.sections-title {
  display: flex;
}

.sections-title .exam-sections {
  background-color: #6fb8ef;
  padding: 5px 15px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
}
.button-create-new {
  display: flex;
  justify-content: flex-end;
}
.exam-sections-name,
.exam-section-desript {
  font-weight: 600;
  padding: 5px;
}

.markdown p {
  margin-block-end: 0 !important;
}

ul {
  padding-left: 0px;
  list-style: none;
  width: 100%;
}
</style>
